<div class="flex flex-col h-full">
  <div>
    <h1>Driftsmeddelelser</h1>
  </div>
  <p-tabs
    [(value)]="driftsMeddelelserService.activeTab"
    class="flex-1 border-1 overflow-hidden">
    <p-tablist>
      <p-tab value="list"><i class="pi pi-list"></i> Liste</p-tab>
      @if (
        driftsMeddelelserService.selectedDriftsMeddelelse() ||
        driftsMeddelelserService.mode() === 'create'
      ) {
        <p-tab value="detail"><i class="pi pi-file"></i> Detaljer</p-tab>
      }
      @if (driftsMeddelelserService.activeTab() !== 'detail') {
        <div class="mt-2 ml-8">
          <p-button
            icon="pi pi-plus"
            outlined
            label="Opret driftsmeddelelse"
            (click)="
              driftsMeddelelserService.opretDriftsMeddelelse()
            "></p-button>
        </div>
      }
    </p-tablist>
    <p-tabpanels class="overflow-hidden">
      <p-tabpanel value="list">
        <app-driftsmeddelelser-list />
      </p-tabpanel>
      <p-tabpanel value="detail">
        <app-driftmeddelelser-detail />
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
